import { Stack } from "@mui/material";

import { type PaymentsListItem } from "../types/PaymentsListItem";
import { PaymentsListItemAmount } from "./PaymentsListItemAmount";
import { PaymentsListItemBadge } from "./PaymentsListItemBadge";
import { PaymentsListItemDescription } from "./PaymentsListItemDescription";
import { PaymentsListItemPill } from "./PaymentsListItemPill";
import { PaymentsListItemTitle } from "./PaymentsListItemTitle";

export interface PaymentsListItemProps {
  item: PaymentsListItem;
}

export function PaymentsListItemComponent(props: PaymentsListItemProps) {
  return (
    <Stack
      sx={(theme) => ({
        width: "100%",
        paddingX: theme.spacing(5),
        paddingY: theme.spacing(4),
        flexDirection: "row",
      })}
      data-testid={`payment-item-${props.item.id}`}
    >
      <PaymentsListItemBadge item={props.item} />
      <Stack
        gap={2}
        sx={(theme) => ({
          flex: 1,
          minHeight: theme.spacing(9),
          alignItems: "flex-start",
          justifyContent: "center",
          marginLeft: theme.spacing(4),
          marginRight: theme.spacing(3),
        })}
      >
        <PaymentsListItemTitle item={props.item} />
        <PaymentsListItemDescription item={props.item} />
      </Stack>
      <Stack
        gap={2}
        sx={(theme) => ({
          minHeight: theme.spacing(9),
          alignItems: "flex-end",
          justifyContent: "center",
        })}
      >
        <PaymentsListItemAmount item={props.item} />
        <PaymentsListItemPill item={props.item} />
      </Stack>
    </Stack>
  );
}
